import { cn } from '@forest/shared'

export function CoinIcon(props: { class?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      aria-hidden="true"
      class={cn('size-5 shrink-0', props.class)}
    >
      <ellipse cx="10" cy="10.59" rx="9" ry="8.41" fill="#de8802" />
      <ellipse cx="10" cy="9.41" rx="9" ry="8.41" fill="#fdda39" />
      <path
        d="M13.64,11.02c-.66,1.43-2.09,2.58-4.09,2.58s-3.62-1.62-3.62-3.62c0-3,2.68-3.75,4.09-3.9,1.27-.13,2.19-.79,2.22-1.93,2.31,2.57,1.95,5.66,1.39,6.87Z"
        fill="#fdbd02"
      />
      <path
        d="M6.68,10.57c0-3,2.68-3.75,4.09-3.9,1.14-.12,2-.66,2.19-1.6-.2-.31-.43-.61-.7-.91-.04,1.14-.95,1.8-2.22,1.93-1.41.15-4.09.9-4.09,3.9,0,1.32.71,2.47,1.76,3.11-.63-.65-1.02-1.54-1.02-2.52Z"
        fill="#de8802"
      />
    </svg>
  )
}
